import React, { useEffect, useState } from "react";
import DisplayController from "../core/DisplayController";
import { storeScreenCode } from "../../services/authService";
import { VerifiedMasjidContext, isVerified } from "./verifiedBadge";

interface HomeScreenViewProps {
  masjidId: number;
  screenCode: string;
}

// The display reads its masjid from this tab's screen identity, so that is set before it mounts.
// HomeShell keys this by masjid and code, so switching starts a fresh display.
const HomeScreenView: React.FC<HomeScreenViewProps> = ({ masjidId, screenCode }) => {
  const [ready, setReady] = useState(false);
  // Official salah times: the badge by the masjid's name, on household tablets only.
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    storeScreenCode(screenCode, String(masjidId));
    setReady(true);
  }, [masjidId, screenCode]);

  useEffect(() => {
    isVerified(masjidId).then(setVerified, () => {});
  }, [masjidId]);

  return ready ? (
    <VerifiedMasjidContext.Provider value={verified}>
      <DisplayController screenCode={screenCode} />
    </VerifiedMasjidContext.Provider>
  ) : null;
};

export default HomeScreenView;
